import { getStorage, ref, uploadBytes } from "firebase/storage";
import { firebaseApp } from "../api/firebase/firestoreService";

interface FileUploadParams {
  file: File;
  project: string;
  bucket: string;
  blob: string;
  url: string;
}

export const uploadFile = async ({
  file,
  project,
  bucket,
  blob,
  url,
}: FileUploadParams): Promise<Response> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("project", project);
  formData.append("bucket", bucket);
  formData.append("blob", blob);

  return fetch(url, {
    method: "POST",
    headers: {
      accept: "application/json",
    },
    body: formData,
  });
};

/**
 * Converts a Blob to a File object
 */
const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, { type: blob.type });
};

interface UploadToFirebaseStorageParams {
  file: Blob | File;
  storagePath: string;
  fileName: string;
}

/**
 * Uploads a file to Firebase Storage
 * @param params - Upload parameters
 * @returns The storage path where the file was uploaded
 */
export const uploadToFirebaseStorage = async ({
  file,
  storagePath,
  fileName,
}: UploadToFirebaseStorageParams): Promise<string> => {
  const storage = getStorage(firebaseApp);
  const storageRef = ref(storage, storagePath);
  const fileToUpload = file instanceof File ? file : blobToFile(file, fileName);
  await uploadBytes(storageRef, fileToUpload);
  return storagePath;
};
